import { tns } from 'tiny-slider';
import AOS from 'aos';
import SmoothScroll from 'smooth-scroll';

/* -----------------------------
  - Vanilla JavaScript
-------------------------------*/
// tiny-slider
var slider = tns({
  container: '#responsive',
  items: 1,
  center: true,
  mode: 'gallery',
  slideBy: 'page',
  controls: false,
  speed: 1500,
  controlsContainer: false,
  nav: false,
  navContainer: false,
  mouseDrag: false,
  autoplay: true,
  autoplayHoverPause: true,
  autoplayButtonOutput: false,
  controls: false,
  swipeAngle: false,
});
var testimonial = tns({
  container: '#testimonial',
  items: 1,
  center: true,
  mode: 'gallery',
  slideBy: 'page',
  controls: false,
  speed: 1500,
  controlsContainer: false,
  nav: false,
  navContainer: false,
  mouseDrag: false,
  autoplay: true,
  autoplayHoverPause: true,
  autoplayButtonOutput: false,
  controls: false,
  swipeAngle: false,
});

// AOS init
AOS.init({
  // AOS would work only for windows bigger than or equal to 1024px
  disable: function() { var maxWidth = 1024; return window.innerWidth < maxWidth; }
});

// smooth scroll
var scroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  offset: 82.35,
});

// Log scroll events
function logScrollEvent(event) {
  if (event.detail.anchor.id === "estimates") {
    document.getElementById("name").focus();
  }
  if (event.detail.anchor.clientWidth >= 1024) {
    document.querySelectorAll(".nav__item").forEach((item) => {
      item.classList.remove('active');
    });
    event.detail.toggle.parentNode.classList += ' active';
  }
}

// Listen for scroll events
document.addEventListener('scrollStop', logScrollEvent, false);

// collapsibles
const collapsibles = document.querySelectorAll('.collapsible');

collapsibles.forEach((item) =>
  item.addEventListener('click', function () {
    this.classList.toggle('collapsible--expanded');
  }),
);

// validate us telephone input field
document.getElementById('phone').addEventListener('input', function (e) {             
  var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);     
  e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
});                                                                                   

// inputPlaceholder
inputPlaceholder(document.getElementById('msg'), '#9bacc8');

// simple validation to form fields
function validateEmail(email) {
  var re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

/* -----------------------------
  - jQuery + Libraries
-------------------------------*/
const jquery = require('jquery');
window.$ = window.jQuery = jquery;

require('jquery.easing');
const validate = require('jquery-validation');

$(document).ready(function () {
  'use strict';

  // sticky + scroll up
  var $window = $(window), 
    $body = $('body'), 
    $winDow = $($window),
    activeSticky = $('#sticky-header'), 
    scrollUp = $('.scroll-to-target');

  $winDow.on('scroll', function () {
    var scroll = $($window).scrollTop(),
      isSticky = activeSticky;

    if (scroll < 135) {
      isSticky.removeClass('is-sticky');
      scrollUp.removeClass('open');
    } else {
      isSticky.addClass('is-sticky');
      scrollUp.addClass('open');
    }

    // if (scroll > 100) {
    //   console.log('back-to-top fadeIn');
    //   // $(".back-to-top").fadeIn();
    // } else {
    //   console.log('back-to-top fadeOut');
    //   // $(".back-to-top").fadeOut();
    // }
  });

  // Scroll Up
  if ($('.scroll-to-target').length) {
    $(".scroll-to-target").on('click', function () {
      var target = $(this).attr('data-target');
      // animate
      $('html, body').animate({
        scrollTop: $(target).offset().top
      }, 1000);
    });
  }

  // form validation
  var ajaxContactForm = function () {
    $('#contactform').each(function () {
      $(this).validate({
        rules: {
          name: {
            required: true,
            minlength: 2,
            maxlength: 120
          },
          email: {
            required: true,
            minlength: 6,
            maxlength: 120
          },
          phone: {
            required: true,
            minlength: 10,
            maxlength: 20
          },
          address: {
            required: false,
            minlength: 5,
            maxlength: 120
          }, 
          body: {
            required: true,
            minlength: 5,
            maxlength: 1000
          }         
        },      
        submitHandler: function (form) {
          var $form = $(form),
            str = $form.serialize(),
            loading = $('<div />', { class: 'loading' });
          $.ajax({
            type: 'POST',
            url: $form.attr('action'),
            data: str,
            async: true,
            beforeSend: function () {
              $form
                .find('.form-submit')
                .after(loading)
                .attr('disabled', 'disabled');
            },
            success: function (data, textStatus, jqXHR) {
              var result, cls;

              if (textStatus === 'success') {
                result = 'Message Sent Successfully.';
                cls = 'msg-success';
              } else {
                result = 'Error sending email.';
                cls = 'msg-error';
              }

              $form.append(
                $('<div />', {
                  class: cls,
                  text: result,
                })
              );

              $form.find(':input').not('.form-submit').val('');
              $('.msg-success').delay(7000).fadeOut('slow');
            },
            complete: function (xhr, status, error_thrown) {
              $form.find('.loading').remove();
              $('.form-submit').removeAttr('disabled');
            },
          });
        },
      });
    }); // each contactform
  };

  // Scroll down
  // $('.scroll-down')
  //   .css('visibility', 'visible')
  //   .addClass('animate__fadeInDown');

  // Smooth scroll
  // $('.nav__list a, .btn-small, .btn--primary-2').on('click', function (event) {
  //   var $anchor = $(this);
  //   $('html, body')
  //     .stop()
  //     .animate(
  //       {
  //         scrollTop: $($anchor.attr('href')).offset().top - 35,
  //       },
  //       1500,
  //       'easeInOutExpo',
  //     );
  //   event.preventDefault();
  // });

  // maxlength
  $('textarea[maxlength]').keyup(function () {
    var limit = parseInt($(this).attr('maxlength'));
    var text = $(this).val();
    var chars = text.length;
    if (chars > limit) {
      var new_text = text.substr(0, limit);
      $(this).val(new_text);
    }
  });

  // Royal Preloader
  var rp = require('./royal_preloader.min.js');
  rp.Royal_Preloader.config({
    mode           : 'logo',
    logo           : new URL('../images/logo-anim.gif', import.meta.url),
    logo_size      : [100, 62],
    showProgress   : true,
    showPercentage : true,
    text_colour: '#f5821f',
    background:  '#ffffff'
  });

  // back to top
  // $(".back-to-top").click(function () {
  //   $("html, body").animate({ scrollTop: 0 }, 1000);
  //   return false;
  // });

  // Dom Ready
  $(function () {
    ajaxContactForm();
  });
});
